import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BotConfigService {
  private botConfigUrl: string;
  private latestVersion: number;

  constructor(private http: HttpClient) {
    this.latestVersion = environment.botConfig.latestVersion;
    this.botConfigUrl = environment.botConfig.url;
  }

  async getBotConfigById(botId: string) {
    try {
      const result = await firstValueFrom(this.http.get(this.botConfigUrl + botId));
      return result;
    } catch (e) {
      console.error('Failed to fetch bot', e);
      throw e;
    }
  }

  async isLastestVersion(botId: string) {
    const url = this.botConfigUrl + botId;
    try {
      const result = await firstValueFrom(this.http.get<Record<string, unknown>>(url));
      if (result) {
        if (result['version'] !== undefined) {
          return parseInt(result['version'] as string) === this.latestVersion;
        }

        if (result['isV3'] !== undefined) {
          return result['isV3'] === false;
        }
      }
    } catch (e) {
      console.error(e);
      return false;
    }
  }
}
